// extracted by mini-css-extract-plugin
export default {"wrapper":"KE-z","button":"LE-z","alternate":"ME-z","disabled":"NE-z","paymentWarning":"OE-z","fadeIn":"PE-z"};